<template>
    <div class="couponEdit">
        <div class="bank_title">
            基本信息
        </div>
        <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="108px" class="ruleForm">
            <el-form-item label="优惠券名称" class="name isRequired" prop="name">
                <el-input :disabled="params.disabled || isEdit" placeholder="输入优惠券名称，不超过10个字" v-model="ruleForm.name" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="优惠券类型" class="type_box isRequired" prop="voucherdistype">
                <div class="type">
                    <el-radio-group v-model="ruleForm.voucherdistype" :disabled="params.disabled || isEdit">
                        <div class="first_radio">
                            <el-radio :label="1">满减优惠券</el-radio>
                        </div>
                        <div>
                            <el-radio :label="2">折扣优惠券</el-radio>
                        </div>
                    </el-radio-group>
                </div>
            </el-form-item>
            <el-form-item label="使用门槛" class="threshold_box isRequired" prop="minordermoney">
                <div class="threshold">
                    <el-radio-group v-model="ruleForm.minordermoney" @change="minordermoneyChange" :disabled="params.disabled || isEdit">
                        <div class="first_radio">
                            <el-radio :label="1">满<el-input :disabled="params.disabled || isEdit" v-model.number="ruleForm.minordermoneyValue"></el-input>元使用</el-radio>
                        </div>
                        <div>
                            <el-radio :label="0">无门槛</el-radio>
                        </div>
                    </el-radio-group>
                </div>
            </el-form-item>
            <el-form-item label="优惠金额" class="faceprice isRequired" prop="faceprice" v-if="ruleForm.voucherdistype === 1">
                <el-input :disabled="params.disabled || isEdit" placeholder="输入优惠券金额" v-model="ruleForm.faceprice"></el-input>元
            </el-form-item>
            <el-form-item label="折扣信息" prop="voucherdisrate" class="voucherdisrate isRequired" v-if="ruleForm.voucherdistype === 2">
                <div class="first_input">
                    打<el-input :disabled="params.disabled || isEdit" @input="voucherdisrateChange" placeholder="输入折扣" v-model="ruleForm.voucherdisrate"></el-input>折
                </div>
                <div class="second_input">
                    <el-form-item prop="maxdismoney">
                        <el-checkbox-group @change="ismaxdismoneyChange" v-model="ruleForm.ismaxdismoney" :disabled="params.disabled || isEdit">
                            <el-checkbox :label="1" name="type">
                                最大优惠<el-input placeholder="最大优惠金额" :disabled="!ruleForm.ismaxdismoney.length || params.disabled || isEdit" v-model.number="ruleForm.maxdismoney"></el-input>元
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </div>
            </el-form-item>
            <el-form-item label="发行量" prop="totalcount" class="totalcount isRequired">
                <el-input placeholder="输入数量" :disabled="(isEdit && ruleForm.totalcount === 0 && !params.iscopy) || params.disabled" v-model.number="ruleForm.totalcount" maxlength="10"></el-input>不超过1,000,000张
                <p class="tips">修改发行量时只能增加不能减少，请谨慎设置</p>
            </el-form-item>
            <el-form-item label="使用商品" class="scope_box isRequired" prop="usescopetype">
                <div class="scope">
                    <el-radio-group v-model="ruleForm.usescopetype" :disabled="params.disabled || isEdit">
                        <div class="first_radio">
                            <el-radio :label="1">本机构所有商品</el-radio>
                        </div>
                        <div>
                            <el-radio :label="2">指定部分商品<el-button @click="handleAddGoods" :disabled="params.disabled" v-if="ruleForm.usescopetype === 2" class="add_goods">增加商品</el-button></el-radio>
                        </div>
                        <div class="goodsList" v-if="ruleForm.kmclist.length && ruleForm.usescopetype === 2">
                            <div class="item" v-for="(item, index) in ruleForm.kmclist" :key="index">
                                <div class="left">
                                    <img :src="item.coverurl" alt="">
                                    <p class="kmcname">{{item.kmcname}}</p>
                                </div>
                                <div class="right">
                                    <p class="kmctypename">{{item.kmctypename}}</p>
                                    <img @click="deleteGoods(item ,index)" :src="require('@/common/images/taskToolsImgs/delete.png')" alt="">
                                </div>
                            </div>
                        </div>
                    </el-radio-group>
                </div>
                <p class="tips">优惠券一旦创建，指定商品只能添加，不能删除。</p>
            </el-form-item>
            <el-form-item label="使用时间" class="time_box isRequired" prop="expiretype">
                <div class="time">
                    <el-radio-group v-model="ruleForm.expiretype" @change="expiretypeChange" :disabled="params.disabled || isEdit">
                        <div class="first_radio">
                            <el-radio :label="0">自定义时间</el-radio>
                            <div>
                                <el-date-picker :disabled="params.disabled || isEdit" v-model="ruleForm.expire" type="daterange" range-separator="至" value-format="yyyy-MM-dd" format="yyyy-MM-dd" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
                            </div>
                        </div>
                        <div class="second_radio">
                            <el-radio :label="1">领取当日起<el-input :disabled="ruleForm.expiretype !== 1 || params.disabled || isEdit" v-model.number="ruleForm.expiredaysbefore" placeholder="输入整数"></el-input>天内</el-radio>
                        </div>
                        <div class="thirdly_radio">
                            <el-radio :label="2">领取次日起<el-input :disabled="ruleForm.expiretype !== 2 || params.disabled || isEdit" v-model.number="ruleForm.expiredaysafter" placeholder="输入整数"></el-input>天内</el-radio>
                        </div>
                    </el-radio-group>
                </div>
            </el-form-item>
            <el-form-item label="领取次数限制" class="countbyper isRequired">
                <el-radio-group v-model="ruleForm.countbyper" :disabled="params.disabled || isEdit">
                    <div class="first_radio">
                        <el-radio :label="0">不限次数<span class="tips">每人最多可领100次</span></el-radio>
                    </div>
                    <div class="second_radio">
                        <el-radio :label="1">
                            每人限领
                            <el-select v-model="ruleForm.countbypercount" :disabled="params.disabled || isEdit">
                                <el-option :label="index+1" :value="index+1" v-for="(item, index) in 100" :key="index"></el-option>
                            </el-select>
                            次
                        </el-radio>
                    </div>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="活动叠加设置">
                <el-checkbox-group v-model="ruleForm.isavoidmutievent" :disabled="params.disabled || isEdit">
                    <el-checkbox :label="1" name="type">优惠券仅原价购买商品可用，不可与其他活动叠加使用，如限时折扣</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item>
                <div class="btn">
                    <el-button type="primary" @click="submit" :disabled="params.disabled">发布</el-button>
                    <el-button @click="cancel">取消</el-button>
                </div>
            </el-form-item>
        </el-form>
        <goodsListDialog ref="goodsListDialog" @setCourseQuesList="_setCourseQuesList" />
    </div>
</template>
<script>
import {addOrUpdateAssetCouponVoucherV2, getMareketingCoupnvoucherInfoV2} from 'api/marketingCenterApi'
import {mapActions, mapGetters} from 'vuex'
import goodsListDialog from '../limittime/components/goodsListDialog'
export default {
    name: 'couponList',
    data() {
        const checkMinordermoney = (rule, value, callback) => {
            if (this.ruleForm.minordermoney === 1) {
                if (!this.ruleForm.minordermoneyValue) {
                    callback(new Error('请输入使用门槛金额'))
                } else {
                    if (parseFloat(this.ruleForm.minordermoneyValue)) {
                        callback()
                    } else {
                        callback(new Error('请输入正确的金额'))
                    }
                }
            } else {
                callback()
            }
        }
        const checkTotalcount = (rule, value, callback) => {
            if (this.isEdit && !this.params.iscopy) {
                if (value < this.editBeforeRuleForm.totalcount) {
                    callback(new Error('发行量不能减少'))
                } else {
                    callback()
                }
            } else {
                if (typeof value === 'number') {
                    if (value === 0) {
                        callback()
                    } else if (value > 1000000) {
                        callback(new Error('请输入正确的发行量'))
                    } else {
                        callback()
                    }
                } else {
                    callback(new Error('请输入正确的发行量'))
                }
            }
        }
        const checkUsescopetype = (rule, value, callback) => {
            if (value === 1) {
                callback()
            } else {
                if (!this.ruleForm.kmclist.length) {
                    callback(new Error('请选择指定商品'))
                } else {
                    callback()
                }
            }
        }
        const checkExpiretype = (rule, value, callback) => {
            if (value === 0) {
                if (!this.ruleForm.expire.length) {
                    callback(new Error('请选择使用时间'))
                } else {
                    callback()
                }
            } else if (value === 1) {
                if (!this.ruleForm.expiredaysbefore) {
                    callback(new Error('请输入使用时间'))
                } else {
                    if (typeof this.ruleForm.expiredaysbefore !== 'number') {
                        callback(new Error('请输入正确的使用时间'))
                    } else {
                        callback()
                    }
                }
            } else if (value === 2) {
                if (!this.ruleForm.expiredaysafter) {
                    callback(new Error('请输入使用时间'))
                } else {
                    if (typeof this.ruleForm.expiredaysafter !== 'number') {
                        callback(new Error('请输入正确的使用时间'))
                    } else {
                        callback()
                    }
                }
            }
        }
        const checkVoucherdisrate = (rule, value, callback) => {
            console.log(value)
            if (!value) {
                callback(new Error('请输入折扣信息'))
            } else if (value > 10) {
                callback(new Error('折扣值不能大于10'))
            } else if (!(value > 0)) {
                callback(new Error('折扣值必须大于0'))
            }
            // else if (this.ruleForm.ismaxdismoney.length) {
            //     if (!this.ruleForm.maxdismoney) {
            //         callback(new Error('请输入最大折扣'))
            //     } else {
            //         if (typeof this.ruleForm.maxdismoney !== 'number') {
            //             callback(new Error('请输入正确的最大折扣'))
            //         }
            //         //  else if (this.ruleForm.minordermoney === 1) {
            //         //     if (this.ruleForm.maxdismoney > this.ruleForm.minordermoneyValue) {
            //         //         callback(new Error('折扣值不能大于使用门槛'))
            //         //     } else {
            //         //         callback()
            //         //     }
            //         // } 
            //         else {
            //             callback()
            //         }
            //     }
            // } 
            else {
                // if (typeof value !== 'number') {
                //     callback(new Error('请输入正确的折扣信息'))
                // } else {
                callback()
                // }
            }
        }
        const checkMaxdismoney = (rule, value, callback) => {
            if (this.ruleForm.ismaxdismoney.length) {
                if (!this.ruleForm.maxdismoney) {
                    callback(new Error('请输入最大优惠金额'))
                } else if (this.ruleForm.maxdismoney <= 0) {
                    callback(new Error('请输入正确的最大优惠金额'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // const checkFaceprice = (rule, value, callback) => {
        //     if (this.ruleForm.minordermoney === 1) {
        //         if (value > this.ruleForm.minordermoneyValue) {
        //             callback(new Error('优惠金额不能大于使用门槛'))
        //         } else {
        //             callback()
        //         }
        //     } else {
        //         callback()
        //     }
        // }
        return {
            ruleForm: {
                name: '', // 优惠券名称
                faceprice: '', // 优惠金额
                voucherdistype: 1, // 优惠类型(1满减优惠券 2折扣优惠券)
                voucherdisrate: '', // 折扣信息 针对打折优惠券有效
                usescopetype: 1, // 使用商品范围(1全部 2部分)
                minordermoney: 1, // 使用条件(满多少钱使用,0不限制)
                minordermoneyValue: '', // 使用门槛金额
                kmclist: [], // 商品ID和类型串(部分用时必传，形如1001_1,1001_2)，如果是编辑，只传新增加的商品信息即可
                expiretype: 0, // 使用时间有效期类型，0自定义 1领取后当日 2领取后次日
                expiredays: '', // 有效天数，领取后当日/次日有效
                expiredaysbefore: '', // 有效天数，领取后当日/次日有效
                expiredaysafter: '', // 有效天数，领取后当日/次日有效
                expirebegindate: '', // 可用开始时间(yyyy-MM-dd HH:mm:ss)
                expireenddate: '', // 可用结束时间(yyyy-MM-dd HH:mm:ss)
                expire: [],
                totalcount: 0, // 发行量(0不限制)
                countbyper: 0, // 每人限领
                countbypercount: 1,
                isavoidmutievent: [], // 是否限制叠加活动使用 0否 1是
                maxdismoney: '', // 最多优惠金额，折扣优惠券有效，0为不限制
                ismaxdismoney: []
            },
            rule: {
                name: [
                    {required: true, message: '请输入优惠券名称', trigger: 'blur'}
                ],
                voucherdistype: [
                    {required: true, message: '请选择优惠券类型', trigger: 'blur'}
                ],
                minordermoney: [
                    {validator: checkMinordermoney, trigger: 'blur'}
                ],
                faceprice: [
                    {required: true, message: '请输入优惠金额', trigger: 'blur'},
                    // {type: 'number', message: '请输入正确的优惠金额'},
                    // {validator: checkFaceprice, trigger: 'blur'}
                ],
                totalcount: [
                    {validator: checkTotalcount, trigger: 'blur'}
                ],
                usescopetype: [
                    {validator: checkUsescopetype, trigger: 'blur'}
                ],
                expiretype: [
                    {validator: checkExpiretype, trigger: 'blur'}
                ],
                voucherdisrate: [
                    {validator: checkVoucherdisrate, trigger: 'blur'}
                ],
                maxdismoney: [
                    {validator: checkMaxdismoney, trigger: 'blur'}
                ]
            },
            isEdit: false,
            params: {
                couponvoucherid: this.$route.query.couponvoucherid,
                iscopy: this.$route.query.iscopy ? 1 : '',
                disabled: false
            },
            editBeforeRuleForm: {}
        }
    },
    mounted() {
        if (this.params.couponvoucherid) {
            this.getMareketingCoupnvoucherInfoV2()
        }
    },
    methods: {
        getMareketingCoupnvoucherInfoV2() {
            this.setLoading(true)
            getMareketingCoupnvoucherInfoV2({
                data: this.params,
                success: res => {
                    this.setLoading(false)
                    if (this.params.iscopy) {
                        this.isEdit = false
                        res.data.customassetList.forEach((obj, index) => {
                            obj.saleprice = ''
                            obj.delete = 1
                        })
                        if (res.data.totalcount === 0) {
                            res.data.totalcount = ''
                        }
                        delete res.data.couponvoucherid
                    } else {
                        this.isEdit = true
                        res.data.customassetList.forEach((obj, index) => {
                            obj.saleprice = ''
                            obj.delete = 0
                        })
                        if (res.data.status !== 1 && !this.params.iscopy) {
                            this.params.disabled = true
                        }
                    }
                    this.editBeforeRuleForm = JSON.parse(JSON.stringify(res.data))
                    if (res.data.expiretype === 0) {
                        res.data.expire = [res.data.expirebegindate, res.data.expireenddate]
                    } else if (res.data.expiretype === 1) {
                        res.data.expiredaysbefore = res.data.expiredays
                    } else if (res.data.expiretype === 2) {
                        res.data.expiredaysafter = res.data.expiredays
                    }
                    if (res.data.minordermoney > 0) {
                        res.data.minordermoneyValue = res.data.minordermoney
                        res.data.minordermoney = 1
                    }
                    if (res.data.countbyper === 0) {
                        res.data.countbypercount = 1
                    } else {
                        res.data.countbypercount = res.data.countbyper
                        res.data.countbyper = 1
                    }
                    res.data.ismaxdismoney = []
                    if (res.data.maxdismoney > 0) {
                        res.data.maxdismoney = parseFloat(res.data.maxdismoney)
                        res.data.ismaxdismoney = [1]
                    } else {
                        res.data.maxdismoney = ''
                    }
                    if (res.data.isavoidmutievent) {
                        res.data.isavoidmutievent = [1]
                    } else {
                        res.data.isavoidmutievent = []
                    }
                    res.data.faceprice = parseFloat(res.data.faceprice)
                    res.data.kmclist = []
                    if (res.data.usescopetype === 2) {
                        res.data.kmclist = res.data.customassetList
                    }
                    delete res.data.customassetList
                    this.ruleForm = res.data
                    console.log(this.ruleForm)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        submit() {
            this.$refs.ruleForm.validate((valid, errlist) => {
                if (valid) {
                    const ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
                    if (ruleForm.usescopetype === 2) {
                        ruleForm.kmcidlist = ''
                        if (this.isEdit) {
                            ruleForm.kmclist.forEach((obj, index) => {
                                if (obj.delete) {
                                    ruleForm.kmcidlist += obj.kmcinnerid + '_' + obj.kmctype
                                    if (index !== ruleForm.kmclist.length - 1) {
                                        ruleForm.kmcidlist += ','
                                    }
                                }
                            })
                        } else {
                            ruleForm.kmclist.forEach((obj, index) => {
                                ruleForm.kmcidlist += obj.kmcinnerid + '_' + obj.kmctype
                                if (index !== ruleForm.kmclist.length - 1) {
                                    ruleForm.kmcidlist += ','
                                }
                            })
                        }
                        console.log(ruleForm.kmclist)
                    }
                    if (ruleForm.expiretype === 0) {
                        ruleForm.expirebegindate = ruleForm.expire[0]
                        ruleForm.expireenddate = ruleForm.expire[1]
                        ruleForm.expiredays = 0
                    } else if (ruleForm.expiretype === 1) {
                        ruleForm.expiredays = ruleForm.expiredaysbefore
                    } else if (ruleForm.expiretype === 2) {
                        ruleForm.expiredays = ruleForm.expiredaysafter
                    }
                    if (ruleForm.minordermoney === 1) {
                        ruleForm.minordermoney = ruleForm.minordermoneyValue
                    }
                    if (ruleForm.isavoidmutievent.length) {
                        ruleForm.isavoidmutievent = 1
                    } else {
                        ruleForm.isavoidmutievent = 0
                    }
                    if (ruleForm.countbyper === 1) {
                        ruleForm.countbyper = ruleForm.countbypercount
                    }
                    delete ruleForm.kmclist
                    delete ruleForm.expire
                    delete ruleForm.expiredaysbefore
                    delete ruleForm.expiredaysafter
                    delete ruleForm.minordermoneyValue
                    delete ruleForm.ismaxdismoney
                    console.log(ruleForm)
                    this.setLoading(true)
                    addOrUpdateAssetCouponVoucherV2({
                        data: ruleForm,
                        success: res => {
                            this.setLoading(false)
                            this.$router.back(1)
                            console.log(res)
                        },
                        error: res => {
                            this.setLoading(false)
                            this.$message.error(res.msg)
                        }
                    })
                } else {
                    this.$message.error('请完善你的数据')
                }
            })
        },
        minordermoneyChange() {
            if (this.ruleForm.minordermoney === 0) {
                this.$refs.ruleForm.validateField('minordermoney')
            }
        },
        voucherdisrateChange() {
            if (this.ruleForm.voucherdisrate.indexOf('.') !== -1) {
                const arr = this.ruleForm.voucherdisrate.split('.')
                if (arr[1].length > 1) {
                    arr[1] = arr[1].slice(0, 1)
                }
                this.ruleForm.voucherdisrate = arr.join('.')
            }
        },
        ismaxdismoneyChange() {
            if (!this.ruleForm.ismaxdismoney.length) {
                this.$refs.ruleForm.validateField('maxdismoney')
            }
            console.log(this.ruleForm.ismaxdismoney)
        },
        expiretypeChange(value) {
            if (value === 1) {
                this.ruleForm.expiredaysafter = ''
            } else if (value === 2) {
                this.ruleForm.expiredaysbefore = ''
            }
            console.log(value)
        },
        cancel() {
            this.$router.back(1)
        },
        deleteGoods(item, index) {
            if (item.delete) {
                this.ruleForm.kmclist.splice(index, 1)
            } else {
                this.$message.error('该商品无法删除')
            }
        },
        handleAddGoods() {
            this.$refs.goodsListDialog.openDialog(JSON.parse(JSON.stringify(this.ruleForm.kmclist)))
        },
        _setCourseQuesList(selectedResult) {
            if (this.isEdit) {
                let str = JSON.stringify(this.ruleForm.kmclist)
                selectedResult.forEach(obj => {
                    if (str.indexOf(obj.kmcinnerid) === -1) {
                        obj.delete = 1
                        this.ruleForm.kmclist.push(obj)
                    }
                })
            } else {
                selectedResult.forEach(obj => {
                    obj.delete = 1
                })
                this.ruleForm.kmclist = selectedResult
            }
            console.log(this.ruleForm.kmclist)
            // selectedResult.forEach((obj, index) => {
            //     arr.forEach((item, i) => {
            //         if (str.indexOf(obj.kmcinnerid) !== -1) {

            //         }
            //     })
            //     obj.delete = 1
            // })
            // console.log(selectedResult)
            // this.page.page = 1
            // this.page.pageCount = parseInt(this.item.kmcinfo.length / 10) + 1
            // this._getList()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        goodsListDialog
    }
}
</script>
<style lang="scss">
    .couponEdit {
        .bank_title {
            padding-left: 8px;
            border-left: 2px solid #409EFF;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 20px;
        }
        .ruleForm {
            padding-left: 8px;
            .el-form-item__label {
                text-align: left;
            }
            .name {
                .el-input {
                    width: 260px;
                }
            }
            .type_box {
                .el-form-item__label {
                    line-height: 20px;
                }
                .type {
                    padding: 20px;
                    box-sizing: border-box;
                    max-width: 805px;
                    background: #F5F7FA;
                    .first_radio {
                        margin-bottom: 20px;
                    }
                }
            }
            .threshold_box {
                .el-form-item__label {
                    line-height: 20px;
                }
                .threshold {
                    padding: 20px;
                    box-sizing: border-box;
                    max-width: 805px;
                    background: #F5F7FA;
                    .first_radio {
                        margin-bottom: 15px;
                        .el-input {
                            width: 100px;
                            margin: 0 10px;
                        }
                    }
                }
            }
            .faceprice {
                .el-input {
                    width: 260px;
                    margin-right: 10px;
                }
            }
            .voucherdisrate {
                .first_input {
                    margin-bottom: 10px;
                    .el-input {
                        width: 138px;
                        margin: 0 10px;
                    }
                }
                .second_input {
                    line-height: 32px;
                    .el-input {
                        width: 138px;
                        margin: 0 10px;
                    }
                }
            }
            .totalcount {
                .el-input {
                    width: 260px;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
                .tips {
                    color: #F56C6C;
                    line-height: 16px;
                }
            }
            .scope_box {
                .scope {
                    max-width: 805px;
                    box-sizing: border-box;
                    padding: 20px;
                    background: #F5F7FA;
                    margin-bottom: 10px;
                    .el-radio-group {
                        width: 100%;
                    }
                    .first_radio {
                        margin-bottom: 20px;
                    }
                    .add_goods {
                        margin-left: 16px;
                    }
                    .goodsList {
                        padding-top: 20px;
                        width: 100%;
                        .item {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            background: #fff;
                            padding-right: 10px;
                            &:not(:last-of-type) {
                                margin-bottom: 10px;
                            }
                            .left {
                                display: flex;
                                align-items: center;
                                img {
                                    width: 54px;
                                    height: 30px;
                                    margin-right: 10px;
                                }
                                .kmcname {
                                    max-width: 525px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    font-size: 14px;
                                    color: #606266;
                                }
                            }
                            .right {
                                display: flex;
                                align-items: center;
                                color: #909399;
                                font-size: 14px;
                                img {
                                    width: 12px;
                                    height: 12px;
                                    margin-left: 15px;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
                .tips {
                    line-height: 16px;
                    color: #F56C6C;
                }
            }
            .time_box {
                .el-form-item__label {
                    line-height: 20px;
                }
                .time {
                    max-width: 805px;
                    box-sizing: border-box;
                    padding: 20px;
                    background: #F5F7FA;
                    .first_radio {
                        .el-date-editor {
                            margin: 12px 0 20px;
                            .el-icon-date, .el-range-separator {
                                line-height: 24px;
                            }
                        }
                    }
                    .second_radio, .thirdly_radio {
                        .el-input {
                            width: 100px;
                            margin: 0 10px;
                        }
                    }
                    .second_radio {
                        margin-bottom: 20px;
                    }
                }
            }
            .countbyper {
                .el-form-item__label {
                    line-height: 14px;
                }
                .first_radio {
                    margin-bottom: 20px;
                    .tips {
                        color: #999999;
                        margin-left: 12px;
                    }
                }
                .second_radio {
                    .el-radio__label {
                        padding-left: 6px;
                    }
                    .el-select {
                        width: 128px;
                        margin: 0 10px 0 4px;
                        .el-select__caret {
                            line-height: 32px;
                        }
                    }
                }
            }
            .is-checked {
                .el-radio__label, .el-checkbox__label {
                    color: #303133;
                }
            }
            .btn {
                .el-button--primary {
                    margin-right: 70px;
                }
            }
            .isRequired {
                .el-form-item__label::before {
                    content: none;
                }
                .el-form-item__label::after {
                    content: '*';
                    color: #F56C6C;
                    font-size: 14px;
                    margin-left: 4px;
                }
            }
        }
    }
</style>